import { p as proxyCustomElement, H, h, d as Host } from './p-bfa0dc67.js';
import { i as inheritAriaAttributes, c as clsx } from './p-50b8bf73.js';
import { n as nanoid } from './p-5959f2bd.js';

const stylesCss = ":host{display:inline-block}:host svg{display:block;width:1em;height:1em;fill:currentColor}:host(.size-2xl){font-size:var(--bi-icon-2xl) !important}:host(.size-xl){font-size:var(--bi-icon-xl) !important}:host(.size-large){font-size:var(--bi-icon-large) !important}:host(.size-medium){font-size:var(--bi-icon-medium) !important}:host(.size-small){font-size:var(--bi-icon-small) !important}:host(.color-inherit){color:inherit}:host(.color-primary){color:#01417b}:host(.color-gray){color:#1c1b1b}:host(.color-black){color:var(--bi-basic-key)}:host(.color-white){color:var(--bi-basic-white)}";
const BiIconChevronUpStyle0 = stylesCss;

const BiIconChevronUp = /*@__PURE__*/ proxyCustomElement(class BiIconChevronUp extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.inheritedAttributes = {};
        this.titleText = null;
        /**
         * The color of the icon.
         * @default 'inherit'
         */
        this.color = 'inherit';
    }
    componentWillLoad() {
        this.inheritedAttributes = inheritAriaAttributes(this.el);
        this.titleText = this.el.getAttribute('title');
        if (this.titleText) {
            this.titleId = `title-${nanoid()}`;
        }
    }
    render() {
        return (h(Host, { key: 'deed6fa8b6511cc2dfdd9df2e36cd5bd8385f304', class: clsx(`color-${this.color}`, this.size && `size-${this.size}`) }, h("svg", { key: 'fe354d23a7aad7ffa3fad2f62936844ea0622819', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 25 25', focusable: 'false', role: 'img', width: '1em', height: '1em', fill: 'currentColor', "aria-labelledby": this.titleId, ...this.inheritedAttributes }, this.titleText ? h("title", { id: this.titleId }, this.titleText) : null, h("path", { key: '5003491c6a2a2e633419d4655ecbfdcf5cde2994', "fill-rule": 'evenodd', d: 'm12.863 8.756 6.522 6.522-1.06 1.06-5.462-5.46-5.46 5.46-1.061-1.06z', "clip-rule": 'evenodd' }))));
    }
    get el() { return this; }
    static get style() { return BiIconChevronUpStyle0; }
}, [1, "bi-icon-chevron-up", {
        "size": [513],
        "color": [513]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bi-icon-chevron-up"];
    components.forEach(tagName => { switch (tagName) {
        case "bi-icon-chevron-up":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BiIconChevronUp);
            }
            break;
    } });
}

export { BiIconChevronUp as B, defineCustomElement as d };
